import classNames from '../../utils/classNames.js';

export default function TabsApi({ setViewNumber, viewNumber, isAdmin }) {
    const allTabs = [
        { name: 'API', href: '#', current: viewNumber === 0, index: 0, adminOnly: false },
        { name: 'Webhook Logs', href: '#', current: viewNumber === 1, index: 1, adminOnly: false },
        { name: 'Usage', href: '#', current: viewNumber === 2, index: 2, adminOnly: true },
        { name: 'Zapier', href: '#', current: viewNumber === 3, index: 3, adminOnly: false },
        { name: 'MCP', href: '#', current: viewNumber === 4, index: 4, adminOnly: false },
    ];

    // Filter tabs based on admin status
    const tabs = isAdmin ? allTabs : allTabs.filter(tab => !tab.adminOnly);

    const handleChange = (event) => {
        const selectedTabName = event.target.value;
        const selectedTabIndex = tabs.find((tab) => tab.name === selectedTabName).index;
        setViewNumber(selectedTabIndex);
    };

    return (
        <div>
            <div className="sm:hidden -mx-4 -my-2">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>
                <select
                    id="tabs"
                    name="tabs"
                    onChange={handleChange}
                    className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                    defaultValue={tabs.find((tab) => tab.current).name}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>
                            {tab.name}{tab.adminOnly ? ' (Admin)' : ''}
                        </option>
                    ))}
                </select>
            </div>
            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                        {tabs.map((tab) => (
                            <button
                                key={tab.name}
                                onClick={() => setViewNumber(tab.index)}
                                className={classNames(
                                    tab.current
                                        ? 'border-indigo-500 text-indigo-600'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium inline-flex items-center gap-2'
                                )}
                                aria-current={tab.current ? 'page' : undefined}
                            >
                                <span>{tab.name}</span>
                                {tab.adminOnly && (
                                    <span className="inline-flex items-center rounded-md bg-indigo-100 px-2 py-0.5 text-xs font-medium text-indigo-700">
                                        Admin
                                    </span>
                                )}
                            </button>
                        ))}
                    </nav>
                </div>
            </div>
        </div>
    )
}

